import { Component, inject, input } from '@angular/core';
import { LoadingUtilsService } from '../../../services/utils/loading-utils-service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-loader',
  imports: [LottieComponent],
  templateUrl: './app-loader.html',
  styleUrl: './app-loader.scss',
})
export class AppLoader {
  loadingService = inject(LoadingUtilsService);
  lottieOptions: AnimationOptions = {
    path: 'assets/lottie/vm_loading_lightmode.json',
    loop: true,
    autoplay: true,
  };
}
